import React from "react";

// Semantic UI React
import { Button, Icon, Popup } from "semantic-ui-react";

// ESRI
import Point from "@arcgis/core/geometry/Point.js";
import Graphic from "@arcgis/core/Graphic.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import * as projection from "@arcgis/core/geometry/projection.js";

export default class LocationWidget extends React.Component {
  constructor(props) {
    super();

    this.state = {
      active: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    // Create the Graphics Layer
    this.layer = new GraphicsLayer({
      id: "LocationLayer",
      print: true,
    });

    // Add the layer to the map
    this.props.view.map.layers.add(this.layer);
  }

  handleClick() {
    var curState = !this.state.active;

    if (curState) {
      this.start();
    } else {
      this.cancel();
      this.removeGraphic();
    }

    this.setState({
      active: curState,
    });
  }

  start() {
    // Clear the interval just in case it is already runnign

    // Fetch the current location immediately
    // => Center and zoom to it
    this.center = true;
    this.getLocation();

    // Set up to ping new location every 5 seconds
    // => Do not center and zoom on update
    this.interval = setInterval(() => {
      this.center = false;
      this.getLocation();
    }, 5000);
  }

  cancel() {
    clearInterval(this.interval);
  }

  getLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      console.error(position);

      projection.load().then(() => {
        // Create the Point
        var point = new Point({
          longitude: position.coords.longitude,
          latitude: position.coords.latitude,
        });

        // Convert the point to map projection
        var mp = projection.project([point], this.props.view.spatialReference);
        this.addGraphic(mp[0]);
      });
    });
  }

  addGraphic(geometry) {
    this.removeGraphic();
    this.graphic = new Graphic({
      geometry: geometry,
      symbol: {
        type: "simple-marker",
        outline: {
          width: 1,
          color: [235, 235, 235, 1],
        },
        color: [36, 36, 36, 0.75],
      },
    });
    this.layer.graphics.add(this.graphic);

    // Only center and zoom if set
    if (this.center) {
      this.props.view.goTo({
        target: geometry,
        zoom: 8,
      });
    }
  }

  removeGraphic() {
    if (this.graphic) {
      this.layer.graphics.remove(this.graphic);
    }
  }

  render() {
    return (
      <Popup
        trigger={
            <Button
            icon
            id="location_button"
            secondary={this.state.active}
            style={{ position: "sticky", marginBottom: "10px" }}
            onClick={() => this.handleClick()}
          >
            <Icon name={this.state.active ? "remove" : "crosshairs"} />
          </Button>
        }
        className={`transition fade in`}
        inverted
        size="tiny"
        content="Locate"
        position="right center"
      />
    );
  }
}
